module.exports = __webpack_public_path__ + "static/rating-6daa7d82b48d8e2f36ff4a2f2ed16c9e.svg";